/**
 *
 * MobileHeaderLayout
 *
 */

import React, { memo, useState, useCallback, useMemo } from 'react';
import { compose } from 'redux';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

// styles
import './style.scss';

// antd component
import { Button, List, Drawer } from 'antd';
import { NavBar } from 'antd-mobile';

// assets
import { MenuOutlined } from '@ant-design/icons';
import CustomIcons from 'components/CustomIcons';

// components
import AppVersionInformation from 'components/AppVersionInformation';
import StudentInfo from 'mobile/components/StudentInfo';

// global user
import {
  withUser,
  useLogout,
  useGetLocalUser,
  useGetLocalActiveChild,
} from 'engine/Contexts/User.context';

function MobileHeaderLayout({
  header,
  user,
  notifications,
  // actions
  notificationsAction,
  // default props
  className,
}) {
  
  const localUser = useGetLocalUser()();
  const activeChild = useGetLocalActiveChild()();

  const roleClass = localUser?.role ? localUser?.role : '';
  const childClassNames = classNames(
    'layout-header-mobile',
    roleClass,
    className,
  );

  const [drawerOpened, setDrawerOpened] = useState(false);

  const logoutUser = useLogout();

  // toggle drawers
  const openDrawer = useCallback(() => {
    setDrawerOpened(prev => !prev);
  }, []);

  // drawers content
  const sidebarMenuForParent = useMemo(() => {
    return (
      <List className="mobile-sidebar-menu students" header={`L’étudiant`}>
        <List.Item
          className="mobile-sidebar-menu__item"
          key={'linkstudent'}
        >
          <Link className="menu-item-link" to={`/linkstudent`} onClick={() => setDrawerOpened(false)}>
            <CustomIcons className="menu-item-icon" type="qrcode" /> QR étudiant
          </Link>
        </List.Item>
        <List.Item
          className="mobile-sidebar-menu__item"
          key={'school-information'}
        >
          <Link className="menu-item-link" to={``} onClick={() => setDrawerOpened(false)}>
            Informations sur l’établissement scolaire
          </Link>
        </List.Item>
        <List.Item
          className="mobile-sidebar-menu__item"
          key={'student-parameter'}
        >
          <Link className="menu-item-link" to={``} onClick={() => setDrawerOpened(false)}>
            Paramètre de l’étudiant
          </Link>
        </List.Item>
      </List>
    );
  }, [setDrawerOpened]);

  const sidebarMenuAccount = useMemo(() => {
    return (
      <List className="mobile-sidebar-menu account" header={`Mon compte`}>
        <List.Item className="mobile-sidebar-menu__item" key={'profile'}>
          Paramètre de mon compte
        </List.Item>

        <List.Item className="mobile-sidebar-menu__item" key={'notifications'}>
          Notifications
        </List.Item>

        <List.Item className="mobile-sidebar-menu__item" key={'communications'}>
          <Link className="menu-item-link" to={`/communications`} onClick={() => setDrawerOpened(false)}>
            News
          </Link>
        </List.Item>

        <List.Item className="mobile-sidebar-menu__item logout" key={'logout'}>
          <Button onClick={logoutUser}>Déconnexion</Button>
        </List.Item>
      </List>
    );
  }, [localUser?._id, logoutUser, setDrawerOpened]);

  const sidebarMenuEnvironnement = useMemo(() => {
    return (
      <List
        className="mobile-sidebar-menu environnement"
        header={`Environnement`}
      >
        <List.Item className="mobile-sidebar-menu__item logout" key={'logout'}>
          <Button onClick={logoutUser}>
            {localUser?.role == 'parent'
              ? `Accéder à mon environnement Enseignant`
              : `Accéder à mon environnement Parent`}
          </Button>
        </List.Item>
      </List>
    );
  }, [logoutUser, localUser?.role]);

  const sideContent = useMemo(() => {
    return (
      <>
        {localUser?.role == 'parent' && !!(user?.activeChild || activeChild) && (
          <StudentInfo dataStudent={user?.activeChild || activeChild} showChangeButton={false} />
        )}
        {localUser?.role == 'parent' && (sidebarMenuForParent)}
        {sidebarMenuAccount}
        {sidebarMenuEnvironnement}
        <AppVersionInformation label="Version:" />
      </>
    );
  }, [user?.activeChild?._id, localUser?.role, localUser?._id, activeChild?._id]);

  const topNavBarRight = useMemo(() => {
    return (
      <>
        <div className="navbar-mobile__toggle" onClick={openDrawer}>
          <MenuOutlined />
        </div>
      </>
    );
  }, [user?.activeChild?._id, localUser?.role, localUser?._id, openDrawer, activeChild?._id]);

  const topHeader = useMemo(() => {
    return (
      header || (
        <>
          <Link className="header-logo" to="/home">
            {localUser?.role == 'teacher' ? (
              <CustomIcons className="header-logo__image" type="logo-white" />
            ): (
              <CustomIcons className="header-logo__image" type="logo" />
            )}
          </Link>
          <div className={`role-information ${localUser?.role}`}>
            {localUser?.role == 'teacher' ? 'Enseignant' : 'Parent'}
          </div>
        </>
      )
    );
  }, [header, localUser?.role, localUser?._id]);

  return (
    <>
      <div className={childClassNames}>
        <NavBar
          className={`navbar-mobile ${localUser?.role}`}
          mode="dark"
          right={topNavBarRight}
          // onLeftClick={() => console.log('onLeftClick')}
          left={null}
          back={null}
          backArrow={null}
        >
          {topHeader}
        </NavBar>
        <Drawer
          key="tcf-mobile-drawer"
          className={`tcf-mobile-drawer ${localUser?.role}`}
          style={{
            minHeight: document.documentElement.clientHeight,
          }}
          contentStyle={{
            color: '#A6A6A6',
            textAlign: 'center',
            paddingTop: 42,
          }}
          sidebar={sideContent}
          open={drawerOpened}
          onClose={openDrawer}
          position={'right'}
          touch={true}
          maskClosable={true}
          docked={false}
          closable={false}
        >
          {sideContent}
        </Drawer>
      </div>
    </>
  );
}

MobileHeaderLayout.defaultProps = {};

export default compose(
  memo,
  withUser,
)(MobileHeaderLayout);
